import { SEOConfigApiItem } from "./services/seoConfig";

export interface PageOption {
  key: string;
  label: string;
}

export const PAGE_OPTIONS: PageOption[] = [
  { key: "home", label: "Home Page" },
  { key: "about", label: "About Page" },
  { key: "contact", label: "Contact Page" },
  { key: "blog_list", label: "Blog List" },
  { key: "blog_post", label: "Blog Post" },
  { key: "product", label: "Product Page" },
  { key: "category", label: "Category Page" },
  { key: "funeral_stream", label: "Funeral Stream" },
  { key: "memorial", label: "Memorial Page" },
  { key: "chema", label: "Chema Fundraising Page" },
];

export const SCHEMA_TYPE_OPTIONS = [
  "WebPage",
  "Article",
  "BlogPosting",
  "Product",
  "Organization",
  "Person",
  "Event",
  "FAQPage",
];

export interface SEOForm {
  pageName: string;
  metaTitle: string;
  metaDescription: string;
  focusKeyword: string;
  relatedKeywords: string[];
  metaKeywords: string;
  canonicalUrl: string;
  noindex: boolean;
  nofollow: boolean;
  ogTitle: string;
  ogType: string;
  ogDescription: string;
  ogImageUrl: string;
  twitterCardType: string;
  twitterTitle: string;
  twitterDescription: string;
  twitterImageUrl: string;
  twitterSite: string;
  twitterCreator: string;
  schemaType: string;
  isActive: boolean;
}

export const EMPTY_FORM: SEOForm = {
  pageName: "",
  metaTitle: "",
  metaDescription: "",
  focusKeyword: "",
  relatedKeywords: [],
  metaKeywords: "",
  canonicalUrl: "",
  noindex: false,
  nofollow: false,
  ogTitle: "",
  ogType: "website",
  ogDescription: "",
  ogImageUrl: "",
  twitterCardType: "summary_large_image",
  twitterTitle: "",
  twitterDescription: "",
  twitterImageUrl: "",
  twitterSite: "",
  twitterCreator: "",
  schemaType: "WebPage",
  isActive: true,
};

export const robotsFromFlags = (noindex: boolean, nofollow: boolean) =>
  `${noindex ? "noindex" : "index"},${nofollow ? "nofollow" : "follow"}`;

export const flagsFromRobots = (robots: string) => ({
  noindex: robots.includes("noindex"),
  nofollow: robots.includes("nofollow"),
});

export const toForm = (config: SEOConfigApiItem): SEOForm => ({
  pageName: config.page_name,
  metaTitle: config.meta_title_template || "",
  metaDescription: config.meta_description_template || "",
  focusKeyword: config.focus_keyword || "",
  relatedKeywords: config.related_keywords || [],
  metaKeywords: config.meta_keywords || "",
  canonicalUrl: config.canonical_url_pattern || "",
  ...flagsFromRobots(config.robots_meta || "index,follow"),
  ogTitle: config.og_title_template || "",
  ogType: config.og_type || "website",
  ogDescription: config.og_description_template || "",
  ogImageUrl: config.og_image_url || "",
  twitterCardType: config.twitter_card_type || "summary_large_image",
  twitterTitle: config.twitter_title_template || "",
  twitterDescription: config.twitter_description_template || "",
  twitterImageUrl: config.twitter_image_url || "",
  twitterSite: config.twitter_site || "",
  twitterCreator: config.twitter_creator || "",
  schemaType: config.schema_type || "WebPage",
  isActive: config.is_active ?? true,
});

export const pageLabel = (pageName: string) =>
  PAGE_OPTIONS.find((page) => page.key === pageName)?.label ||
  pageName
    .replaceAll("_", " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
